<template>
  <div class="home">
    <img class="log" alt="Vue logo" src="../assets/elongpaoxiao.jpg">
    <HelloWorld msg="欢迎来到我的个人博客"/>

    <h2>!来听一首歌吧！</h2>
    <audio controls autoplay="autoplay">
      <!-- <source src="../music/(TV Verison)Y.mp3" type="audio/mpeg"> -->
      <source src="../music/3.mp3" type="audio/mpeg">
    </audio>

    <div class="DayWord">
      <h3>每日一言:</h3>
      <p class="DayWord_p">{{ DayWord.hitokoto }}——《{{ DayWord.from }}》</p>
    </div>

    <!-- <div class="Weather">
      <p>城市：江西 - 赣州</p>
      <p>今日天气：{{ Weather.textDay }}</p>
      <p>现在温度：{{ DayWeather.aqi - 7 }}</p>
      <p>今日气温：{{ Weather.tempMin }} ~ {{ Weather.tempMax }}</p>
    </div> -->
    

  </div>
  
</template>
<style>
  body{
    background-image: url('../assets/bizhi.png');
    background-size: cover;
    background-attachment: fixed;
  }

  .log{
   width: 100px;
   height: 100px; 
  }

  .DayWord{
    width: 70%;
    margin: auto;
    font-size: 30px;
    background-color: beige;
    background: rgba(255,255,255,0.4);
  }

  .DayWord_p{
    font-size: 30px;
    /* background-color: beige; */
    
  }

  .Weather{
    width: 20%;
    height: 40%;
    position: fixed;
    top:30px;
	  right:30px;

    margin: auto;
    font-size: 30px;
    background-color: beige;
    background: rgba(255,255,255,0.4);
  }
</style>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'
import axios from "axios"
//import querystring from "querystring"

export default {
  name: 'HomeView',
  components: {
    HelloWorld
  },

  data(){
    return{
      DayWord:{},
      Weather:{},
      DayWeather:{}
    }
  },
  mounted(){
    //刷新页面自动播放
    // var audio = document.getElementsByTagName("audio")[0];
    // audio.volume = 0.5; //设置音量为50%
    // window.onload = function() {
    //   audio.play();
    // },

    //get请求，每日一言 
    axios({
      method:"get",
      url:"https://v1.hitokoto.cn/"
    }).then(res => {
      console.log(res.data);
      console.log(typeof res.data);
      this.DayWord = res.data;
    });

    axios({
      method : "get",
      //url : "https://devapi.qweather.com/v7/air/now?location=101240701&key=4741d18d2cf84fa9b4bb4dc0cf3ab791",
      url : "https://devapi.qweather.com/v7/weather/3d?location=101240701&key=4741d18d2cf84fa9b4bb4dc0cf3ab791",
      // data : {
      //   key: '4741d18d2cf84fa9b4bb4dc0cf3ab791',
      //   //地区编码
      //   location: '101240701'
      // }
    }).then(res => {
      console.log(res.data.daily);
      this.Weather = res.data.daily[0];
    })

    axios({
      method : "get",
      url : "https://devapi.qweather.com/v7/air/now?location=101240701&key=4741d18d2cf84fa9b4bb4dc0cf3ab791",
      //url : "https://devapi.qweather.com/v7/weather/3d?location=101240701&key=4741d18d2cf84fa9b4bb4dc0cf3ab791",
      // data : {
      //   key: '4741d18d2cf84fa9b4bb4dc0cf3ab791',
      //   //地区编码
      //   location: '101240701'
      // }
    }).then(res => {
      console.log(res.data);
      this.DayWeather = res.data.now;
    })

    
  }
}

</script>
